import MedicineSaleDialog from "./MedicineSaleDialog";
import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { FaCashRegister, FaFileMedical, FaFileExcel } from "react-icons/fa";
import ImageDialog from "./Admin/Treatment Sale/ImageDialog";
// import { translateRect } from '../../pluginsfullcalendar/main.d';
import { useSelector } from "react-redux";
import { Button } from "@mantine/core";
import BASE_API_URL from "../../api/api";
import apiInstance from "../../Utils/api";
function TreatementSale() {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  //const url = "http://localhost:9000/api/"
  const api = apiInstance

  const scroll = {
    height: "600px",
    overflowY: "scroll",
  };

  const _export = React.useRef(null);
  const _export1 = React.useRef(null);
  const excelExport = () => {
    if (_export.current !== null) {
      // console.log(_export.current.props.data.filter(el => el.repaymentAmount1), 'exc')

      // console.log(uniqueArray, 'ii')
      _export.current.props.data.map(function (element, index) {
        element.itemDiscount = element.item.discountAmount
          ? element.item.discountAmount
          : 0;
        element.itemQty = element.item.qty ? element.item.qty : 0;
        element.date1 = element?.repaymentDate1?.split("T")[0];
        element.date2 = element?.repaymentDate2?.split("T")[0];
        element.date3 = element?.repaymentDate3?.split("T")[0];
        element.firstPaidAmount = element.totalAmount - element.totalDiscount;
        element.remainingAmount =
          (element.balance !== 0 &&
            element.totalAmount - element.totalDiscount) -
          ((element?.repaymentAmount1 ? element?.repaymentAmount1 : 0) +
            (element?.repaymentAmount2 ? element?.repaymentAmount2 : 0) +
            (element?.repaymentAmount3 ? element?.repaymentAmount3 : 0));
        element.secondAmount = element.secondAmount ? element.secondAmount : 0;
        element.secondAccount = element.secondAccount
          ? element.secondAccount.name
          : "Not Set";
        // console.log(uniqueArray.filter(el => el._id === element._id), 'totl')
        element.createdAt = element.createdAt
          ? element.createdAt.split("T")[0]
          : "";
      });
      _export.current.save();
    }
  };

  const excelExport1 = () => {
    if (_export1.current !== null) {
      // console.log(_export.current.props.data)
      // console.log(_export1.current.props.data.filter(el => el.repaymentAmount1), 'exc')
      const arrayList = _export1.current.props.data;
      // console.log(arrayList)
      arrayList.map(function (element, index) {
        element.itemDiscount = element.item.discountAmount
          ? element.item.discountAmount
          : 0;
        element.itemQty = element.item.qty ? element.item.qty : 0;
        element.date1 = element?.repaymentDate1?.split("T")[0];
        element.date2 = element?.repaymentDate2?.split("T")[0];
        element.date3 = element?.repaymentDate3?.split("T")[0];
        element.firstPaidAmount = element.totalAmount - element.totalDiscount;
        element.remainingAmount =
          (element.balance !== 0 &&
            element.totalAmount - element.totalDiscount) -
          ((element?.repaymentAmount1 ? element?.repaymentAmount1 : 0) +
            (element?.repaymentAmount2 ? element?.repaymentAmount2 : 0) +
            (element?.repaymentAmount3 ? element?.repaymentAmount3 : 0));
        element.secondAmount = element.secondAmount ? element.secondAmount : 0;
        element.secondAccount = element.secondAccount
          ? element.secondAccount.name
          : "Not Set";
        element.createdAt = element.createdAt
          ? element.createdAt.split("T")[0]
          : "";
      });
      _export1.current.save();
    }
  };

  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const today_date = today.toISOString().split("T")[0];
  // console.log(today_date)
  const [bankRefundList, setBankRefundList] = useState([]);
  const [cashRefundList, setCashRefundList] = useState([]);
  const [cashExcelList, setCashExcelList] = useState([]);
  const [bankExcelList, setBankExcelList] = useState([]);
  const [todayList, setTodayList] = useState([]);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [payFilterList, setPayFilterList] = useState([]);
  const [show, setShow] = useState(false);
  const [users, setUsers] = useState([]);
  const [branches, setBranches] = useState([]);
  const [branchID, setBranchID] = useState("");
  const [userID, setUserID] = useState("");
  const [open, setOpen] = useState("");
  const [close, setClose] = useState("");
  const [value, setValue] = useState("");
  const [imgList, setImgList] = useState([]);
  const [purchaseType, setPurchaseType] = useState("");

  const [bankTotal, setBankTotal] = useState(0);
  const [cashTotal, setCashTotal] = useState(0);

  const [bankIncomeList, setBankIncomeList] = useState([]);
  const [cashIncomeList, setCashIncomeList] = useState([]);
  const [bankNameList, setBankNameList] = useState([]);
  const [cashNameList, setCashNameList] = useState([]);
  const [bcshow, setBCShow] = useState("bankTable");
  const [refund, setRefund] = useState("");
  const [showRefund, setShowRefund] = useState(false);

  const showDialog = (val) => {
    const imgPath = imgList.filter((item) => item._id === val);
    console.log(imgPath, "imgPath");
    setValue(imgPath[0].payment ? imgPath[0].payment.imgUrl : "");
    setOpen(true);
  };

  const filter = (event) => {
    let data = {
      start: startDate,
      end: endDate,
    };
    // console.log(branchID, 'b id')
    if (userID) data.createdBy = userID;
    if (branchID) data.relatedBranch = branchID;
    if (purchaseType) data.purchaseType = purchaseType;
    api
      .post("treatment-vouchers/filter", data)

      .then((res) => {
        // setTodayList([])
        setTodayList(res.data.data);
        // console.log(res.data.data, 'vou data')
        setShow(false);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error.response.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleAllFilter = async () => {
    const nDate = new Date(endDate);
    const toDate = nDate.setDate(nDate.getDate() + 1);
    try {
      Swal.fire({
        title: "Loading",
        text: "Please wait...",
        allowOutsideClick: false,
        showConfirmButton: false,
      });
      let data = {};
      if (startDate && endDate) {
        data.startDate = startDate;
        data.endDate = endDate;
      }
      if (branchID) data.relatedBranch = branchID;
      if (userID) data.createdBy = userID;
      if (purchaseType) data.purchaseType = purchaseType;
      await api
        .get(`treatment-vouchers/TV-Filter`, { params: data })
        .then((res) => {
          // setAccountLists(res.data.data)
          //setTransactionLists(res.data.transaction)
          // console.log(res.data.data)
          setBankTotal(res.data.data.BankTotal);
          setCashTotal(res.data.data.CashTotal);
          setBankIncomeList(
            res.data.data.BankList.filter(
              (el) => el.tsType === "TS" || el.tsType === "TSMulti",
            ),
          );
          setCashIncomeList(
            res.data.data.CashList.filter(
              (el) => el.tsType === "TS" || el.tsType === "TSMulti",
            ),
          );
          setShowRefund(true);
          setBankNameList(res.data.data.firstBankNames);
          setCashNameList(res.data.data?.CashNames);
          // console.log(res.data.data.BankNames, 'data list')
        })
        .catch((error) => {
          console.log("error", error);
        });

      await api
        .get(`treatment-vouchers/data/medicine/excel`, { params: data })
        .then((res) => {
          if (res.data.treatment.filter((el) => el.relatedCash)) {
            // setCashTotal(res.data.data?.CashTotal)

            setCashExcelList(res.data.treatment.filter((el) => el.relatedCash));

            // console.log(res.data.treatment.filter(
            //   el => el.relatedCash
            // ), 'cash excel')
          }

          if (res.data.treatment.filter((el) => el.relatedBank)) {
            // setBankTotal(res.data.data?.BankTotal)

            setBankExcelList(res.data.treatment.filter((el) => el.relatedBank));
            // console.log(res.data.treatment.filter(
            //   el => el.relatedBank
            // ), 'bank excel')
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
      Swal.close();

      // Process the response data
      //console.log(data);
    } catch (error) {
      Swal.close();
      // console.error('Error occurred while fetching data.', error)
    }
  };

  const handleRefund = (val) => {
    if (val === "Refund") {
      setRefund(val);
      setCashRefundList(
        cashIncomeList.filter(
          (el) => el.Refund === false || el.Refund === true,
        ),
      );
      // console.log(
      //   cashIncomeList.filter(el => el.Refund === false || el.Refund === true),
      //   'ref'
      // )
      setBankRefundList(
        bankIncomeList.filter(
          (el) => el.Refund === false || el.Refund === true,
        ),
      );
    } else {
      setRefund("");
      handleAllFilter();
    }
  };

  const filterBankType = async (value) => {
    const bankFiltered = bankIncomeList.filter(
      (item) => item.bankType === value,
    );
    const cashFiltered = cashIncomeList.filter(
      (item) => item.bankType === value,
    );
    setBankIncomeList(bankFiltered);
    setCashIncomeList(cashFiltered);
  };
  useEffect(() => {
    const getBranches = async () => {
      api.get("branches").then((res) => {
        setBranches(res.data.list);
      });
    };
    const getUsers = async () => {
      api.get("users").then((res) => {
        setUsers(res.data.list);
      });
    };
    // const getImageList = async () => {
    //   await api.get('treatment-vouchers').then(res => {
    //     // setImgList(res.data.list.filter(el => el.isDeleted === true && el.relatedBranch === '64743985dab649311f9fcc33'))
    //     // console.log(res.data.list.filter(el => el.isDeleted === true && el.relatedBranch === '64743985dab649311f9fcc33'), 'img List')
    //     console.log(res.data.list, 'img url')
    //   })
    // }
    // getImageList()
    getBranches();
    getUsers();
    // getTodayTreatmentVoucher()
  }, []);
  return (
    <>
      {/* @include('sweet::alert') */}

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item active fs-5 text-bold">
                      Treatment Sales Report
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className="row ml-2">
            <div className="form-group col-md-2">
              <label>From</label>
              <input
                type="date"
                name="from"
                id="from"
                className="form-control"
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="form-group col-md-2">
              <label>To</label>
              <input
                type="date"
                name="to"
                id="to"
                className="form-control"
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            {/* <div className='form-group col-md-2' style={{ marginTop: '2.5em' }}>
              <select
                class='custom-select border-info'
                name='account_type_id'
                onChange={paymentFilter}
              >
                <option>Choose Payment</option>
                <option value='by Appointment'>By Appointment</option>
                <option value='Advanced'>Advanced</option>
              </select>
            </div> */}
            <div className="form-group col-md-2" style={{ marginTop: "2.5em" }}>
              <select
                class="custom-select border-info"
                name="account_type_id"
                onChange={(e) => setUserID(e.target.value)}
              >
                <option hidden>Choose User</option>
                {users.map((e, i) => (
                  <option value={e._id}>{e.givenName}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-2" style={{ marginTop: "2.5em" }}>
              <select
                class="custom-select border-info"
                name="account_type_id"
                onChange={(e) => setBranchID(e.target.value)}
              >
                <option hidden>Choose Branch</option>
                {branches.map((e, i) => (
                  <option value={e._id}>{e.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-2" style={{ marginTop: "2.5em" }}>
              <select
                class="custom-select border-info"
                name="account_type_id"
                onChange={(e) => setPurchaseType(e.target.value)}
              >
                <option hidden>Choose Type</option>
                <option value="Solid Beauty">Solid Beauty</option>
                <option value="Normal">Normal</option>
              </select>
            </div>
            <div className="form-group col-md-2">
              <button
                className="btn  btn-primary "
                style={{ marginTop: "35px" }}
                onClick={handleAllFilter}
              >
                Filter
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-flex justify-content-between">
                    {/* <div className='row'>
                      <div className='col-12'>
                        <select
                          class='custom-select border-info'
                          name='account_type_id'
                          onChange={e => filterBankType(e.target.value)}
                        >
                          <option hidden>Filter By Doctor</option>
                          <option value=''>Doctor</option>
                        </select>
                      </div>
                    </div> */}
                    <div className="cold-md-2">
                      <select
                        class="custom-select border-info"
                        name="account_type_id"
                        onChange={(e) => filterBankType(e.target.value)}
                      >
                        <option hidden>Choose Bank Type</option>
                        <option value="POS">POS</option>
                        <option value="Normal">Normal</option>
                        <option value="Pay">Pay</option>
                      </select>
                    </div>
                    {showRefund && (
                      <div className="form-group col-md-2">
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          onChange={(e) => handleRefund(e.target.value)}
                        >
                          <option hidden>Refund ?</option>

                          <option value="All">All</option>
                          <option value="Refund">Refund</option>
                        </select>
                      </div>
                    )}
                    <div className="d-flex float-center">
                      <div className="" style={{ marginRight: "5px" }}>
                        <Button
                          color="cyan"
                          radius="sm"
                          size="sm"
                          onClick={() => setBCShow("bankTable")}
                        >
                          Bank({bankTotal} MMK)
                        </Button>
                      </div>

                      <div className="">
                        <Button
                          color="cyan"
                          radius="sm"
                          size="sm"
                          onClick={() => setBCShow("cashTable")}
                        >
                          Cash({cashTotal} MMK)
                        </Button>
                      </div>
                    </div>

                    <div className="col-2">
                      {bcshow == "bankTable" ? (
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={excelExport}
                        >
                          <FaFileExcel />
                          &nbsp;Export
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-sm btn-success"
                          onClick={excelExport1}
                        >
                          <FaFileExcel />
                          &nbsp;Export
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-body" style={scroll}>
                  {/* Export data in Excel */}
                  {bcshow == "bankTable" ? (
                    <ExcelExport
                      data={bankExcelList}
                      ref={_export}
                      fileName="Treatment_BankList.xlsx"
                    >
                      <ExcelExportColumn
                        field=""
                        title="No"
                        locked={true}
                        width={30}
                      />
                      <ExcelExportColumn
                        field="createdAt
"
                        title="Date"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={200}
                      />
                      <ExcelExportColumn
                        field="code
"
                        title="Voucher No"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="relatedPackage.name
"
                        title="Package Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="relatedPatient.name
"
                        title=" Patient"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="relatedDoctor.name
"
                        title=" Doctor"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="item.item_id.treatmentCode
"
                        title="Treatment Item Code"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="item.item_id.name
"
                        title="Treatment Item Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={450}
                      />

                      <ExcelExportColumn
                        field="bankType"
                        title="Bank Type"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="paymentMethod"
                        title="Payment Method"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="item.price
"
                        title="Item Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="itemDiscount"
                        title="Item Discount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="itemQty"
                        title="Item Qty"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="totalAmount
"
                        title="Grand Total"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="totalDiscount"
                        title="Total Discount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="firstPaidAmount
"
                        title="Paid Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="relatedBank.name"
                        title="First Account"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />

                      <ExcelExportColumn
                        field="totalPaidAmount
"
                        title="First Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="secondAccount
"
                        title="Second Account"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="secondAmount
"
                        title="Second Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="balance
"
                        title="Balance"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date1
"
                        title="Repay Date 1"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount1
"
                        title="Repay Amount 1"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date2
"
                        title="Repay Date 2"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount2
"
                        title="Repay Amount 2"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date3
"
                        title="Repay Date 3"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount3
"
                        title="Repay Amount 3"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentRemaininngCredit
"
                        title="Repayment Remaining"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="relatedBranch.name
"
                        title="Branch"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="createdBy.givenName
"
                        title="User"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="remark
"
                        title="Remark"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                    </ExcelExport>
                  ) : (
                    <ExcelExport
                      data={cashExcelList}
                      ref={_export1}
                      fileName="Treatment_CashList.xlsx"
                    >
                      <ExcelExportColumn
                        field=""
                        title="No"
                        locked={true}
                        width={30}
                      />
                      <ExcelExportColumn
                        field="createdAt
"
                        title="Date"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={200}
                      />
                      <ExcelExportColumn
                        field="code
"
                        title="Voucher No"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="hi
"
                        title="Package Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="relatedPatient.name
"
                        title=" Patient"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="relatedDoctor.name
"
                        title=" Doctor"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="item.item_id.treatmentCode
"
                        title="Treatment Item Code"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={250}
                      />
                      <ExcelExportColumn
                        field="item.item_id.name
"
                        title="Treatment Item Name"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={450}
                      />

                      <ExcelExportColumn
                        field="paymentMethod"
                        title="Payment Method"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="item.price
"
                        title="Item Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="itemDiscount"
                        title="Item Discount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="itemQty"
                        title="Item Qty"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="totalAmount
"
                        title="Grand Total"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="totalDiscount"
                        title="Total Discount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="firstPaidAmount
"
                        title="Paid Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="relatedCash.name"
                        title="First Account"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="totalPaidAmount
"
                        title="First Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="secondAccount
"
                        title="Second Account"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                      <ExcelExportColumn
                        field="secondAmount
"
                        title="Second Amount"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="balance
"
                        title="Balance"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date1
"
                        title="Repay Date 1"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount1
"
                        title="Repay Amount 1"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date2
"
                        title="Repay Date 2"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount2
"
                        title="Repay Amount 2"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="date3
"
                        title="Repay Date 3"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentAmount3
"
                        title="Repay Amount 3"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="repaymentRemaininngCredit
"
                        title="Repayment Remaining"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="relatedBranch.name
"
                        title="Branch"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />

                      <ExcelExportColumn
                        field="createdBy.givenName
"
                        title="User"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={150}
                      />
                      <ExcelExportColumn
                        field="remark
"
                        title="Remark"
                        headerCellOptions={{
                          textAlign: "center",
                        }}
                        cellOptions={{
                          textAlign: "center",
                        }}
                        width={350}
                      />
                    </ExcelExport>
                  )}

                  {/* Export Data in Excel end */}
                  <table id="example1" className="table">
                    <thead
                      className="sticky-top bg-light"
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      <tr>
                        {!refund && (
                          <>
                            <th>No</th>
                            <th>Date</th>
                            <th>Voucher No</th>
                            <th>Patient</th>
                            <th>Doctor</th>
                            <th>Type</th>
                            <th>Payment Method</th>
                            <th>Grand Total</th>
                            <th>Paid Amount</th>
                            <th>Balance</th>
                            <th>Second Acc</th>
                            <th>Second Amount</th>
                            <th>Branch</th>
                            <th>User</th>
                            <th>
                              {bcshow === "bankTable"
                                ? "Bank Name"
                                : "Cash Name"}
                            </th>
                            <th>{bcshow === "bankTable" && "Bank Type"}</th>
                            <th>Remark</th>
                            <th className="text-center">Action</th>
                          </>
                        )}

                        {refund && (
                          <>
                            <th>No</th>
                            <th>Refund Date</th>
                            <th>Voucher No</th>
                            <th>Grand Total</th>
                            <th>Paid Amount</th>
                            <th>Balance</th>
                            <th>Refund Status</th>
                            <th>Refund Reason</th>
                            <th>Refund Type</th>
                            <th>Refund Amount</th>
                            <th>New Voucher</th>

                            <th className="text-center">Action</th>
                          </>
                        )}
                      </tr>
                    </thead>

                    {bcshow === "bankTable"
                      ? !refund &&
                        bankIncomeList.map((tSale, i) => (
                          <tbody key={tSale._id}>
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {tSale.createdAt
                                  ? tSale.createdAt.split("T")[0]
                                  : ""}
                              </td>
                              <td>{tSale.code ? tSale.code : ""}</td>
                              <td>
                                {tSale.relatedPatient
                                  ? tSale.relatedPatient.name
                                  : ""}
                              </td>
                              <td>
                                {tSale.relatedDoctor
                                  ? tSale.relatedDoctor.name
                                  : ""}
                              </td>
                              <td>
                                {tSale.tsType === "MS" ? "Medicine Sale" : ""}
                                {tSale.tsType === "TS"
                                  ? "Single Treatment"
                                  : ""}
                                {tSale.tsType === "TSMulti"
                                  ? "Multiple Treatment"
                                  : ""}
                              </td>
                              <td>
                                {tSale.paymentMethod ? tSale.paymentMethod : ""}
                              </td>
                              <td>{tSale?.totalAmount}</td>
                              <td>{tSale?.totalPaidAmount}</td>
                              <td>
                                {tSale.totalAmount === tSale.totalPaidAmount
                                  ? "0"
                                  : tSale.totalAmount - tSale.totalPaidAmount}
                              </td>
                              <td>
                                {tSale.secondAccount
                                  ? tSale.secondAccount.name
                                  : "Not Set"}
                              </td>
                              <td>
                                {tSale.secondAmount ? tSale.secondAmount : "0"}
                              </td>
                              <td>
                                {tSale.relatedBranch
                                  ? tSale.relatedBranch.name
                                  : ""}
                              </td>
                              <td>
                                {tSale.createdBy
                                  ? tSale.createdBy.givenName
                                  : ""}
                              </td>
                              <td>
                                {tSale.relatedBank
                                  ? tSale.relatedBank.name
                                  : ""}
                              </td>
                              <td>{tSale?.purchaseType}</td>
                              <td>{tSale.remark}</td>
                              <td className="text-center">
                                <button
                                  class="btn btn-primary btn-sm"
                                  onClick={() => showDialog(tSale._id)}
                                >
                                  Image
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))
                      : !refund &&
                        cashIncomeList.map((tSale, i) => (
                          <tbody key={tSale._id}>
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {tSale.createdAt
                                  ? tSale.createdAt.split("T")[0]
                                  : ""}
                              </td>
                              <td>{tSale.code ? tSale.code : ""}</td>
                              <td>
                                {tSale.relatedPatient
                                  ? tSale.relatedPatient.name
                                  : ""}
                              </td>

                              <td>
                                {tSale.relatedDoctor
                                  ? tSale.relatedDoctor.name
                                  : ""}
                              </td>
                              <td>
                                {tSale.msTotalAmount
                                  ? "Medicine Sale"
                                  : "Treatment Sale"}
                              </td>

                              <td>
                                {tSale.paymentMethod ? tSale.paymentMethod : ""}
                              </td>

                              <td>{tSale?.totalAmount}</td>
                              <td>{tSale?.totalPaidAmount}</td>
                              <td>
                                {tSale?.totalAmount === tSale.paidAmount
                                  ? "0"
                                  : tSale?.totalAmount - tSale.totalPaidAmount}
                              </td>
                              <td>
                                {tSale.secondAccount
                                  ? tSale.secondAccount.name
                                  : "Not Set"}
                              </td>
                              <td>
                                {tSale.secondAmount ? tSale.secondAmount : "0"}
                              </td>

                              <td>
                                {tSale.relatedBranch
                                  ? tSale.relatedBranch.name
                                  : ""}
                              </td>

                              <td>
                                {tSale.createdBy
                                  ? tSale.createdBy.givenName
                                  : ""}
                              </td>
                              <td>
                                {tSale.relatedCash
                                  ? tSale.relatedCash.name
                                  : ""}
                              </td>
                              <td></td>

                              <td>{tSale.remark ? tSale.remark : ""}</td>
                              {/* <td>
                            {medicineSaleList.relatedTreatment.treatmentName}
                          </td>
                          {/* <td>{tSale.relatedPatient.name}</td>

                          <td>{tSale.paymentMethod}</td>
                          <td>
                            {tSale.totalAmount
                              .toLocaleString()}
                          </td> */}

                              <td className="text-center">
                                <button
                                  class="btn btn-primary btn-sm"
                                  onClick={() => showDialog(tSale._id)}
                                >
                                  Image
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}

                    {bcshow === "bankTable"
                      ? refund &&
                        bankRefundList.map((tSale, i) => (
                          <tbody key={tSale._id}>
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {tSale.refundDate
                                  ? tSale.refundDate.split("T")[0]
                                  : ""}
                              </td>
                              <td>{tSale.code ? tSale.code : ""}</td>

                              <td>{tSale?.totalAmount}</td>
                              <td>{tSale?.paidAmount}</td>
                              <td>
                                {tSale.totalAmount === tSale.paidAmount
                                  ? "0"
                                  : tSale.totalAmount - tSale.paidAmount}
                              </td>

                              <td>{tSale?.Refund ? "Refund" : "-"}</td>
                              <td>
                                {tSale.refundReason ? tSale.refundReason : "-"}
                              </td>
                              <td>
                                {tSale.refundType ? tSale.refundType : "-"}
                              </td>
                              <td>{tSale ? tSale.refundAmount : "-"}</td>
                              <td>
                                {tSale.newTreatmentVoucherCode
                                  ? tSale.newTreatmentVoucherCode
                                  : "-"}
                              </td>

                              <td className="text-center">
                                <button
                                  class="btn btn-primary btn-sm"
                                  onClick={() => showDialog(tSale._id)}
                                >
                                  Image
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))
                      : refund &&
                        cashRefundList.map((tSale, i) => (
                          <tbody key={tSale._id}>
                            <tr>
                              <td>{++i}</td>
                              <td>
                                {tSale.refundDate
                                  ? tSale.refundDate.split("T")[0]
                                  : ""}
                              </td>
                              <td>{tSale.code ? tSale.code : ""}</td>

                              <td>{tSale?.totalAmount}</td>
                              <td>{tSale?.paidAmount}</td>
                              <td>
                                {tSale.totalAmount === tSale.paidAmount
                                  ? "0"
                                  : tSale.totalAmount - tSale.paidAmount}
                              </td>

                              <td>
                                {refund && (tSale?.Refund ? "Refund" : "-")}
                              </td>
                              <td>
                                {tSale.refundReason ? tSale.refundReason : "-"}
                              </td>
                              <td>
                                {tSale.refundType ? tSale.refundType : "-"}
                              </td>
                              <td>{tSale ? tSale.refundAmount : "-"}</td>
                              <td>
                                {tSale.newTreatmentVoucherCode
                                  ? tSale.newTreatmentVoucherCode
                                  : "-"}
                              </td>

                              <td className="text-center">
                                <button
                                  class="btn btn-primary btn-sm"
                                  onClick={() => showDialog(tSale._id)}
                                >
                                  Image
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                  </table>
                </div>

                <div className="d-flex ">
                  <div style={{ marginRight: "100px", marginLeft: "50px" }}>
                    <p>
                      <b>
                        <u>Bank List</u>
                      </b>
                    </p>
                    {bankNameList
                      ? bankNameList.map((k, v) => (
                          <p>
                            {k.bankname} : {k.amount}{" "}
                          </p>
                        ))
                      : ""}
                  </div>

                  <div>
                    <p>
                      <b>
                        <u>Cash List</u>
                      </b>
                    </p>
                    {Object.entries(cashNameList).map(([k, v]) => (
                      <p>
                        {k} : {v}{" "}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ImageDialog open={open} close={() => setOpen(false)} value={value} />
        </div>

    </>
  );
}
export default TreatementSale;
